import React from "react";
import { ConfirmationDialog } from "../../../assets/types/common";

import { Constants } from "../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../assets/vfx";
import Drawer from "../../../assets/vfx/drawer/drawer";
import DisplayData from "../../common/DisplayData/DisplayData";

import { VfxDialogProps } from "../../../assets/vfx/dialog/vfxDialogProps";
import { LookupDto } from "../../../services/dto/account/lookupDto";
import { ClaimDto } from "../../../services/dto";

export interface ClaimViewProps {
  data?: ClaimDto;
  show: boolean;
  claimTypes: LookupDto[];
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const ClaimView = (props: ClaimViewProps) => {
  const dialogProps: VfxDialogProps | undefined = new ConfirmationDialog().get(
    props.onDelete,
    "Delete",
    {
      Name: props.data?.name ?? Constants.emptyString,
    }
  );

  const claimType =
    props.claimTypes?.find((x) => x.id === props.data?.claimTypeId)?.name ??
    Constants.emptyString;

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      title="View Claim"
      modalDialogProps={dialogProps}
      onHide={props.onHide}
      onEdit={props.onEdit}
      onDelete={props.onDelete}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data.name} />
          <DisplayData
            text="Description"
            importedData={props.data.description ?? Constants.emptyString}
          />
          <DisplayData text="Type" importedData={claimType} />
        </>
      )}
    </Drawer.View>
  );
};
